import type { DrillingMode } from './store/types';

export const WOB_MIN = 0;
export const WOB_MAX = 30;
export const WOB_STEP = 1;

export const RPM_MIN = 0;
export const RPM_MAX = 200;
export const RPM_STEP = 10;

export const RPMTOT_MIN = 0;
export const RPMTOT_MAX = 600;
export const RPMTOT_STEP = 20;

export const DPRESS_MIN = 0;
export const DPRESS_MAX = 40;
export const DPRESS_STEP = 2;

export const DEPTH_MIN = 0;
export const DEPTH_MAX = 2000;

export const DEFAULT_MODES = {
  rotor: 'load',
  slide: 'load',
} satisfies Record<'rotor' | 'slide', DrillingMode>;
